const React = require('react')
import '../../css/shared/SearchProgress.css'

export default class SearchProgress extends React.Component {
  render() {
    const marginPx = (this.props.margin || 0) + 'px'
    return (
      <div className="text-center" style={{width: this.props.size + 'px', height: this.props.size + 'px', margin: marginPx + ' auto'}}>
        <div className="spinner">
          <div className="dot1"></div>
          <div className="dot2"></div>
        </div>
      </div>
    )
  }
}